import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import uploadPhoto from "../../../../Image/upload 1.png";
import delivery_truck from "../../../../Image/admin/delivery-truck-1.png";
import { ToastContainer, toast } from "react-toastify";
import "./AdminViewQuote.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
}));

const AdminViewQuote = () => {
  const classes = useStyles();
  const [file, setPdfFile] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useFetch(
    `https://abc-backend.onrender.com/api/quotes/${id}`
  );
  const notify = () => {
    toast.success("Successfully Added !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const error = () => {
    toast.error("Only PDF Allow", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let quoteId = id;
    const newData = {
      quoteId,
    };
    if (file) {
      const data = new FormData();
      const fileName = Date.now() + file.name;
      data.append("name", fileName);
      data.append("file", file);
      newData.pdf = fileName;
      console.log(newData);
      console.log(file);
      if (file.type === "application/pdf") {
        try {
          await axios.post(
            "https://abc-backend.onrender.com/api/uploads",
            data
          );
        } catch (err) {}
      } else {
        error();
      }
    }
    try {
      //abc-backend.onrender.com/api/articles/image
      await axios
        .post("https://abc-backend.onrender.com/api/pdfquote/pdfquote", newData)
        .then((res) => {
          if (res.data) {
            notify();
            navigate("/siteadmin/req");
            // window.location.reload();
          }
        });
    } catch (error) {
      console.log(error);
    }
    try {
      data.InProgress = true;
      data.open = false;
      await axios.put(
        `https://abc-backend.onrender.com/api/quotes/${id}`,
        data
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="adminTReq">
      <form className="admin_viewQuote" onSubmit={handleSubmit}>
        <div className="rede_transport">
          <div className="rede_transport_img">
            <img src={delivery_truck} alt="delivery truck" />
          </div>
          <div className="rede_transport_text">
            <h6>Rode Transport</h6>
          </div>
        </div>
        <div className="upload_img_main">
          <div className="upload_img">
            <input
              className={classes.input}
              id="icon-button-photo"
              type="file"
              name="file"
              accept=".pdf"
              onChange={(e) => setPdfFile(e.target.files[0])}
            />
            <label htmlFor="icon-button-photo">
              <img src={uploadPhoto} alt="uploadPhoto" />
            </label>
          </div>
          <div className="admin_quote_upload_text">
            <h6>Please upload the quote here.</h6>
          </div>
        </div>
        <div className="admin_quote_upload_btn">
          <Link to={"/siteadmin/req"}>
            <button className="common-btn admin_quote_upload_btn1">Back</button>
          </Link>
          <button className="common-btn">Submit</button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
};

export default AdminViewQuote;
